import { tv } from '~/utils/tv'

export const CardInformativeRootVariants = tv({
  base: `
    flex min-w-[16.25rem] border-none rounded-smallcontainer p-fourpulse justify-start items-center
  `,
  variants: {
    variants: {
      neutral: `
            bg-fill-neutral-alternative
          `,
      positive: `
            bg-fill-success
          `,
      informative: `
            bg-fill-informative
          `,
      warning: `
            bg-fill-warning
          `,
      negative: `
            bg-fill-danger
          `,
    },
    type: {
      icon: 'gap-threepulse',
      highlight: 'gap-fourpulse',
      text: '',
    },
  },
})
